import { css } from '../styled';

export const respondTo = {
  mobile: <T extends object>(...args: Parameters<typeof css<T>>) => css`
    @media screen and ${({ theme }) => theme.breakpoints.mobile} {
      ${css(...args)};
    }
  `,

  HPA: <T extends object>(...args: Parameters<typeof css<T>>) => css`
    @media screen and ${({ theme }) => theme.breakpoints.hpa} {
      ${css(...args)};
    }
  `,

  mqHPA: <T extends object>(...args: Parameters<typeof css<T>>) => css`
    @media screen and ${({ theme }) => theme.breakpoints.mqHPA} {
      ${css(...args)};
    }
  `,

  sitebar: <T extends object>(...args: Parameters<typeof css<T>>) => css`
    @media screen and ${({ theme }) => theme.breakpoints.sitebar} {
      ${css(...args)};
    }
  `,

  DOOH: <T extends object>(...args: Parameters<typeof css<T>>) => css`
    @media screen and ${({ theme }) => theme.breakpoints.DOOH} {
      ${css(...args)};
    }
  `,

  largeMobile: <T extends object>(...args: Parameters<typeof css<T>>) => css`
    @media screen and ${({ theme }) => theme.breakpoints.largeMobile} {
      ${css(...args)};
    }
  `,

  billboard: <T extends object>(...args: Parameters<typeof css<T>>) => css`
    @media screen and ${({ theme }) => theme.breakpoints.billboard} {
      ${css(...args)};
    }
  `,
};
